import { Stack, Box, Typography } from "@mui/material";
import React from "react";

const ServiceRightButton = () => {
  return (
    <Stack direction={"row"} justifyContent={"center"}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        bgcolor={"#B3E4B3"}
        height={{ md: "48px", sm: "48px", xs: "48px" }}
        width={{ md: "324px", sm: "324px", xs: "271px" }}
        borderRadius={"30px"}
        // marginTop={7}
        // marginBottom={1}
      >
        <Typography
          padding={5}
          color={"white"}
          fontSize={{ md: "14px", sm: "14px", xs: "10px" }}
          fontWeight={400}
        >
          Create Payment Link
        </Typography>
      </Box>
    </Stack>
  );
};

export default ServiceRightButton;
